import React, { useState } from "react";
import { Input } from "../../components/Form";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { forgotApi } from "../../services/auth/Auth";
import toast from "react-hot-toast";
import useButtonLoader from "../../hooks/UseButtonLoader";
import MailOutlineTwoToneIcon from "@mui/icons-material/MailOutlineTwoTone";

const ForgotPassword = () => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
  const [error, setError] = useState({});
  const navigate = useNavigate();
  const [buttonref, buttonLoader] = useButtonLoader("Send", "#28B17B");
  const [login, setLogin] = useState({ email: "" });

  const handleValidation = () => {
    const error = {};
    let status = true;

    if (!login.email) {
      error["email"] = "Please Enter Your Email";
      status = false;
    } else if (!emailRegex.test(login.email)) {
      toast.error("Please Enter Valid Email");
      status = false;
    }
    setError(error);
    return status;
  };
  const onChangeHandler = (event) => {
    const { name, value } = event.target;
    setLogin({ ...login, [name]: value });
  };
  const sendEmail = async (e) => {
    e.preventDefault();
    if (handleValidation()) {
      try {
        buttonLoader(true);
        const res = await forgotApi(login);
        if (res.data.status === 200) {
          buttonLoader(false);
          setLogin({ email: "" });
          toast.success(res?.data?.message);
          localStorage.setItem("email", login.email);
          navigate("/verify-otp");
        } else {
          buttonLoader(false);
          toast.error(res?.data?.message);
        }
      } catch (error) {
        buttonLoader(false);
        toast.error(e.message);
      }
    }
  };
  return (
    <>
      <div className="LoginArea">
        <h1 className="login_head">Neptune</h1>
        <div className="LoginBox">
          <h5 className="mt-2">Enter Email ID</h5>
          <p className="text-center fs-6">
            Please enter your registered Email ID <br />
            We will send you an OTP to create a <br /> new password.
          </p>
          <form>
            <div className="form-group">
              <Input
                label={"Email ID"}
                type="text"
                name="email"
                value={login.email}
                onChange={onChangeHandler}
                placeholder="Enter Email ID"
                className={`form-control `}
                error={error.email}
                maxLength={40}
                leftIcon={
                  <span className="Icon">
                    <MailOutlineTwoToneIcon />
                  </span>
                }
              />
            </div>

            <div className="form_btn">
              <button className="login_btn" ref={buttonref} onClick={sendEmail}>
                <Link>
                  Send <i className="fa fa-sign-in"></i>
                </Link>
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default ForgotPassword;
